document.addEventListener("DOMContentLoaded", () => {
  const slider = document.getElementById("brandSlider");
  const arrowLeft = document.querySelector(".brand-arrow.left");
  const arrowRight = document.querySelector(".brand-arrow.right");

  if (!slider || !arrowLeft || !arrowRight) return;

  const scrollAmount = 300;

  function updateArrows() {
    const maxScrollLeft = slider.scrollWidth - slider.clientWidth;

    // Esquerda
    if (slider.scrollLeft <= 5) {
      arrowLeft.style.opacity = "0";
      arrowLeft.style.pointerEvents = "none";
    } else {
      arrowLeft.style.opacity = "1";
      arrowLeft.style.pointerEvents = "auto";
    }

    // Direita
    if (slider.scrollLeft >= maxScrollLeft - 5) {
      arrowRight.style.opacity = "0";
      arrowRight.style.pointerEvents = "none";
    } else {
      arrowRight.style.opacity = "1";
      arrowRight.style.pointerEvents = "auto";
    }
  }

  arrowLeft.addEventListener("click", () => {
    slider.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  });

  arrowRight.addEventListener("click", () => {
    slider.scrollBy({ left: scrollAmount, behavior: "smooth" });
  });

  slider.addEventListener("scroll", updateArrows);
  window.addEventListener("resize", updateArrows);

  updateArrows();
});
document.addEventListener("DOMContentLoaded", () => {
  const phoneBtn = document.querySelector(".copy-phone");

  if (!phoneBtn) return;

  phoneBtn.addEventListener("click", () => {
    const phone = phoneBtn.dataset.phone;

    navigator.clipboard.writeText(phone).then(() => {
      const original = phoneBtn.textContent;
      phoneBtn.textContent = "Copiado!";
      
      setTimeout(() => {
        phoneBtn.textContent = original;
      }, 1200);
    });
  });
});
